import React, { useState, useEffect } from "react";
import NightlifeMenuDetailPage from "../common/NightlifeMenuDetailPage";
import NightLifeSidebar from "../layouts/NightLifeSidebar";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import AppConstants from "../../appConstants";
import { authCall, fetchData } from "../../services";

function NightlifeMenu() {
  const location = useLocation();
  const { nightlifeId } = location.state || {};
  const navigate = useNavigate();
  const companyDetails = useSelector((state) => state.companyDetails);
  const [menuDetails, setMenuDetails] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function fetchRecords() {
      const resp = await fetchData(`getNightlifeMenu/${companyDetails?.id}`);
      if (resp?.type === "success") {
        setMenuDetails(resp?.payload);
      }
    }
    fetchRecords();
  }, [companyDetails]);

  const handleSubmitForm = async (data) => {
    setLoading(true);
    data.nightlifeId = companyDetails?.id;
    const resp = await authCall("createNightlifeMenu", data);
    if (resp?.type === "success") {
      setLoading(false);
      if (data.buttonId === 2) {
        navigate(AppConstants.routes.admin.dashboard);
      } else {
        navigate(AppConstants.routes.nightLife.eventDetails);
      }
    }
  };

  const buttons = [
    // {
    //   id: 1,
    //   label: "Add Anonter Menu",
    //   type: "another",
    // },
    // {
    //   id: 3,
    //   label: "Submit",
    //   type: "done",
    // },
    {
      id: 1,
      label: "Add Event",
    },
    {
      id: 2,
      label: "Dashboard",
    },
  ];

  return (
    <>
      <NightlifeMenuDetailPage
        onSubmit={handleSubmitForm}
        loading={loading}
        nightlifeId={nightlifeId}
        heading="Create Your Menu"
        Sidebar={NightLifeSidebar}
        buttons={buttons}
        details={menuDetails}
        companyDetails={companyDetails}
      />
    </>
  );
}

export default NightlifeMenu;
